export const zhCN = {
  common: {
    studentProfileChangeRequest: {
      loadError: '无法加载修改申请',
      notFound: '申请不存在或你没有查看权限。',
      back: '返回修改记录',
      title: '学生信息修改申请',
      changes: '修改内容',
      changesHint: '高亮部分为申请修改后的值。',
      source: '提交来源',
      submittedAt: '提交时间',
      empty: '没有可展示的字段变化',
      viewProfile: '查看当前学生信息',
      awaitingReview: '等待你的审批',
      rejectionReason: '驳回原因',
      reasonPlaceholder: '选填，建议说明需要修改的内容',
      reasonHint: '仅在驳回时发送给申请人。',
      approve: '通过并应用修改',
      reject: '驳回申请',
      actionError: '处理失败，请稍后重试。',
      before: '修改前',
      after: '修改后',
      fullName: '姓名',
      gender: '性别',
      schoolProfile: '住宿与住址',
      boardingStatus: '住宿状态',
      dormitoryNumber: '宿舍号',
      dayStudentAddress: '走读地址',
      homeAddress: '家庭住址',
      pending: '审批中',
      approved: '已通过',
      rejected: '已驳回',
      applied: '已生效',
      studentSource: '学生提交',
      guardianSource: '家长提交',
      advisorSource: '班主任修改',
      adminSource: '学校管理员修改',
      notFilled: '未填写',
      male: '男',
      female: '女',
      boarding: '住校',
      dayStudent: '走读',
      yes: '是',
      no: '否',
      updated: '已更新',
      rejectedTitle: '申请未通过',
      approvedTitle: '申请已通过',
      appliedTitle: '修改已生效',
      processedTitle: '申请已处理',
      rejectedDescription: '本次修改不会应用到学生档案。',
      approvedDescription: '本次修改已审批通过，系统将按流程应用。',
      appliedDescription: '本次修改已更新到当前学生档案。',
      processedDescription: '本次申请当前无需进一步操作。',
      loading: '正在加载修改申请',
      retryLater: '请稍后重试。',
      changeCount: '{{count}} 项',
    },
    actions: {
      retry: '重试',
      back: '返回上一页',
      backHome: '返回首页',
      relogin: '重新登录',
    },
    language: { label: '语言', zhCN: '简体中文', enUS: 'English' },
    theme: { toDark: '切换到深色模式', toLight: '切换到浅色模式' },
    forbidden: {
      title: '403 · 无权访问',
      description: '你没有访问该页面的权限。',
    },
    notFound: {
      title: '页面不存在',
      description: '你访问的页面不存在、已被移动，或当前版本暂未开放。',
    },
  },
  shell: {
    account: '账号',
    overview: '概览',
    workspaces: '工作区',
    createOrJoin: '创建或加入组织',
    logout: '退出登录',
    loading: '加载中…',
    enteringWorkspace: '正在进入工作区…',
    backToWorkspaces: '返回工作区选择',
    userFallback: '用户',
    notifications: '通知',
    unreadNotifications: '{{count}} 条未读通知',
    myWorkspaces: '我的工作区',
    currentWorkspace: '当前工作区',
    currentWorkspaceSettings: '当前工作区设置',
    accountActions: '账号',
    useInvitationCode: '使用邀请码',
    switchWorkspace: '切换工作区',
    noWorkspaces: '还没有可用的工作区',
    groups: {
      teaching: '教学工作',
      management: '教务管理',
      collaboration: '协作工具',
      personal: '个人中心',
      setup: '教务设置',
    },
    navigation: {
      overview: '概览',
      myCourses: '我的课程',
      myClasses: '我的班级',
      quizzes: '作业',
      myQuizzes: '我的作业',
      grading: '批改中心',
      grades: '成绩管理',
      attendance: '考勤',
      leave: '请假',
      timetable: '日历',
      members: '成员管理',
      classes: '行政班管理',
      academics: '学年与学期',
      questions: '题库',
      collaboration: '校际协作',
      courses: '课程',
      programs: '专业',
      platform: '租户管理',
      aiWorkspace: 'AI 工作区',
      inbox: '消息',
      materials: '资料库',
      families: '家庭',
      parentCenter: '家长中心',
      settings: '设置',
      studentProfile: '学生档案',
    },
    roles: {
      owner: '所有者',
      admin: '管理员',
      schoolAdmin: '学校管理员',
      teacher: '教师',
      headTeacher: '班主任',
      student: '学生',
      guardian: '家长',
      member: '成员',
    },
  },
} as const;

type WidenTranslationValues<Value> = Value extends string
  ? string
  : { readonly [Key in keyof Value]: WidenTranslationValues<Value[Key]> };

export type TranslationResources = WidenTranslationValues<typeof zhCN>;
